import React, { FunctionComponent, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Button, Chip, Theme, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterModal from "@/Domains/DispositionManagement/Components/DispositionControls/Elements/Filter/Elements/FilterModal";
import { useAppSelector } from "@/Redux/Redux";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface DispositionControlsFilterProps {
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    dispositionControlsFilter: {
        width: 307,
        position: "relative",
        borderRight: "1px solid #c3c4c7",
        minHeight: "61px",
        // @ts-ignore
        backgroundColor: theme.palette.background.darker,
    },

    filterBadgesWrapper: {
        padding: "5px 0",
        position: "absolute",
        height: "100%",
        paddingLeft: "15px",
        width: "75%",
    },

    filterButtonWrapper: {
        position: "absolute",
        padding: "5px 0",
        right: 0,
        marginRight: "15px",
        width: "25%",
        display: "flex",
        alignItems: "center",
        height: "100%",
    },

    filterButton: {
        fontSize: "75%",
        marginTop: "auto",
        marginBottom: "auto",
    },

    startIcon: {
        marginRight: 0,
    },
}));

const Filter: FunctionComponent<
    DispositionControlsFilterProps
> = ({ viewData }): JSX.Element => {
    const { classes } = useStyles();
    const [open, setOpen] = useState(false);
    const disposition = useAppSelector((state) => state.disposition);
    const app = useAppSelector((state) => state.app);
    const { t } = useTranslation();

    const STATIONS_SIZE = viewData?.stationList?.station?.length;
    const VEHICLE_GROUPS_SIZE = viewData?.vehicleGroupList?.vehicleGroups?.length;
    const EQUIPMENTS_SIZE = viewData?.equipmentList?.equipments?.length;

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <div className={classes.dispositionControlsFilter}>
                <div className={classes.filterBadgesWrapper}>
                    {disposition.stationFilter.length > 0 &&
                        disposition.stationFilter.length < STATIONS_SIZE && (
                            <Chip
                                label={t("disposition.filter.stations")}
                                size={"small"}
                            />
                        )}
                    {disposition.vehicleGroupFilter.length > 0 &&
                        disposition.vehicleGroupFilter.length <
                            VEHICLE_GROUPS_SIZE && (
                            <Chip
                                label={t("disposition.filter.groups")}
                                size={"small"}
                            />
                        )}
                    {disposition.equipmentFilter.length > 0 &&
                        disposition.equipmentFilter.length <
                            EQUIPMENTS_SIZE && (
                            <Chip
                                label={t("disposition.filter.equipment")}
                                size={"small"}
                            />
                        )}
                </div>
                <div className={classes.filterButtonWrapper}>
                    <Tooltip
                        title={t("disposition.controls.tooltip.showFilter")}
                    >
                        <Button
                            variant="outlined"
                            data-testid={"filterDispo"}
                            color={"secondary"}
                            size={"small"}
                            startIcon={<AddIcon fontSize={"small"} />}
                            onClick={handleClickOpen}
                        >
                            Filter
                        </Button>
                    </Tooltip>
                </div>
            </div>
            <FilterModal open={open} onClose={handleClose} viewData={viewData} />
        </>
    );
};

export default Filter;
